const LoadSpiner = () => {
  return (
    <div className="animate-spin rounded-full h-7 w-7 border-4 border-blue-300"></div>
  );
};

export default LoadSpiner;
